import COOKIE from 'js-cookie'
import config from '@/service/config'
import store from '@/store'
import utils from '@/utils/utils'
const { isApple, isWebLogin } = utils

const mainDomain = config.mainDomain
// const mainDomain = 'yflife.app'

/**
 * 设置登录信息cookie
 * @param {String} uin
 * @param {String} session
 * @param {String} mmaclientid
 * @param {String} tradeSession
 * @api public
 */
export function setLoginCookie (uin, session, mmaclientid, tradeSession) {
  if (!uin || !session || !isApple() || isWebLogin()) {
    return
  }
  COOKIE.set('uin', uin, {
    domain: mainDomain
  })

  COOKIE.set('session', session, {
    domain: mainDomain
  })

  COOKIE.set('mmaclientid', mmaclientid, {
    domain: mainDomain
  })

  COOKIE.set('trade_session', tradeSession, {
    domain: mainDomain
  })
}

/**
 * 移除登录信息cookie
 * @api public
 */
export function clearLoignCookie () {
  if (isApple()) {
    COOKIE.remove('uin', { domain: mainDomain })
    COOKIE.remove('session', { domain: mainDomain })
    COOKIE.remove('mmaclientid', { domain: mainDomain })
  }
}

/**
 * 登录信息是否存在
 */
export function isLoginCookieExist () {
  const uin = COOKIE.get('uin', { domain: mainDomain })
  const session = COOKIE.get('session', { domain: mainDomain })
  if (uin !== store.uin || session !== store.session) {
    return false
  }
  return true
}
